export enum DonorOrigin {    
    Microsite = 1,
    NkrKpd = 2,
    InternalKpd = 3,
    StandardVoucher = 4,
    FamilyVoucher = 6,
    Direct = 5,
    Other = 99
}